import { Component, OnInit } from '@angular/core';
import { MicroempresarioService } from '../services/microempresario.service';
import { UserService } from '../../services/user.service';
import { Router } from '@angular/router';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { SweetAlertService } from '../../services/sweet-alert.service';
import { PerfilSolicitudService } from '../perfil/solicitud/perfil-solicitud.service';
import {
  PERFIL_HUB_ROUTE,
  PERFIL_SOLICITUD_ENVIADA_ROUTE,
} from '../perfil/progress/perfil-section-nav';
import { HOME_COPY } from './data/home-microempresario.content';
import {
  HOME_BANNER_IMAGE_JURIDICA,
  HOME_BANNER_IMAGE_JURIDICA_MOBILE,
  HOME_BANNER_IMAGE_NATURAL,
  HOME_BANNER_IMAGE_NATURAL_MOBILE,
} from './data/home-banner-images';
import {
  HOME_SOLICITUD_FILTROS,
  HomeSolicitudFiltro,
  matchesHomeFiltro,
  resolveHomeEstadoVisual,
} from './data/home-solicitud-estado';
import { HomeCancelarModalStep } from './home-cancelar-modal/home-cancelar-modal.component';
import { HomeInfoModalVariant } from './home-info-modal/home-info-modal.component';
import { AnalyticsTagService } from 'src/app/services/analytics-tag.service';

declare const $: any;

interface ParametroFilterBody {
  idParametro: string;
  nombre: null;
  isParFuncional: boolean;
  pagina: number;
}

interface ParametroFilterResponse {
  exitoso?: boolean;
  data?: Array<{ valorParametro?: string | number }>;
}

interface SolicitudesAprobadasResponse {
  exitoso?: boolean;
  data?: unknown[];
  paginas?: number;
}

interface PorcentajeSolicitudResponse {
  exitoso?: boolean;
  porcentaje?: number | null;
  camposLlenados?: number;
  camposObligatorios?: number;
  validezDocumentos?: boolean;
  estadoDocumentos?: string;
  solicitud?: string;
  message?: string;
  error?: string;
}

const cancelarSolicitud: {
  idSolicitud: string;
  observacion: string;
  idUsuario: number | null;
} = {
  idSolicitud: '',
  observacion: '',
  idUsuario: null,
};

const MENSAJE_ENVIO_SOLICITUD = 'PAR-077';
const PARAMETRO_MENSAJE_SIN_COBERTURA = 'PAR-098';
const PARAMETRO_MONTO_MAX_CREDITO_EXPRESS = 'PAR-068';
const PARAMETRO_MONTO_MIN_CREDITO_EXPRESS = 'PAR-069';
const PARAMETRO_PLAZO_MAX_CREDITO_EXPRESS = 'PAR-071';
const SOLICITUD_COMPLETA = 'PAR-099';
const DOCUMENTOS_VENCIDOS = 'PAR-106';
const MENSAJE_VALIDAR_REGISTRO = 'PAR-129';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent implements OnInit {
  readonly copy = HOME_COPY;
  readonly filtros = HOME_SOLICITUD_FILTROS;

  solicitudes: any[] = [];
  name = '';
  fullName = '';
  isJuridica = false;
  user: any;
  solicitudesAprobadas: unknown[] = [];
  paginaActual = 1;
  totalPaginas: number | null = null;
  idSolicitud: unknown;
  observacionCierreSolicitud = '';
  numeroSolicitud: string | number | null = null;
  mensaje = '';
  mensajeRestriccion = '';
  observacionDevolucion: string | null = null;
  idsolicitudDevuelta: string | null = null;
  mensajeSinCobertura = '';
  mensajeEnvio = '';
  mensajeRegistro = '';
  solicitudCompleta = '';
  documentosVencidos = '';
  porcentajeProcesoSolicitud = 0;
  idSolicitudProceso = '';
  montoMaxExpress: number | null = null;
  montoMinExpress: number | null = null;
  plazoMaxExpress: number | null = null;

  filtroActivo: HomeSolicitudFiltro = 'todos';
  enviarModalOpen = false;
  enviandoSolicitud = false;
  cancelarModalOpen = false;
  cancelarModalStep: HomeCancelarModalStep = 'form';
  confirmandoCancelacion = false;
  infoModalOpen = false;
  infoModalVariant: HomeInfoModalVariant = 'sin-cobertura';
  finalizandoInfoModal = false;
  private solicitudesCargadas = false;

  get portraitSrc(): string {
    return this.isJuridica ? HOME_BANNER_IMAGE_JURIDICA : HOME_BANNER_IMAGE_NATURAL;
  }

  get portraitSrcMobile(): string {
    return this.isJuridica
      ? HOME_BANNER_IMAGE_JURIDICA_MOBILE
      : HOME_BANNER_IMAGE_NATURAL_MOBILE;
  }

  constructor(
    private _user: UserService,
    private _microempresario: MicroempresarioService,
    private _router: Router,
    private _bancoldexService: BancoldexService,
    private _sweetAlert: SweetAlertService,
    private _perfilSolicitud: PerfilSolicitudService,
    private _analyticsTag: AnalyticsTagService
  ) {
    this.user = this._user.getUser();
    this.getMensajeEnvio();
    this.getMensajeValidarRegsitro();
    this.getSolicitudCompleta();
    this.getDocumentosVencidos();
    this.getMontoCreditoExpress();
  }

  ngOnInit(): void {
    this.cargarDatosTabla();
    this.getMensajeSinCobertura();
    const nombre = this._user.getUser()?.nombre ?? '';
    this.fullName = nombre;
    this.name = nombre.split(' ')[0] || '';
    this.isJuridica = this._user.getUser()?.tipoPersona === 'juridica';

    setTimeout(() => {
      this.getSolicitudes(+this.user.idEmpresario);
    }, 1000);
  }

  get solicitudesFiltradas(): any[] {
    return (this.solicitudes || []).filter((s) =>
      matchesHomeFiltro(
        Number(s.idEstadoSolicitud_NeoEstadoSolicitud),
        this.filtroActivo
      )
    );
  }

  setFiltro(filtro: HomeSolicitudFiltro): void {
    this.filtroActivo = filtro;
  }

  estadoVisual(solicitud: any) {
    return resolveHomeEstadoVisual(
      Number(solicitud.idEstadoSolicitud_NeoEstadoSolicitud),
      solicitud.estadoSolicitud,
      solicitud.solicitudDesembolsada
    );
  }

  puedeCancelar(solicitud: any): boolean {
    const id = Number(solicitud.idEstadoSolicitud_NeoEstadoSolicitud);
    return id === 1 || id === 5;
  }

  /**
   * Hub (edición) solo en borrador/devuelta.
   * Resto sin CTA contextual: detalle de solo lectura.
   * Si ya hay otra acción (ofertas, encuesta, explorar…), no mostrar Ver detalle.
   */
  puedeVerDetalle(solicitud: any): boolean {
    return !this.accionContextualLabel(solicitud);
  }

  /** true → hub perfil; false → detalle compartido. */
  verDetalleVaAlHub(solicitud: any): boolean {
    const id = Number(solicitud.idEstadoSolicitud_NeoEstadoSolicitud);
    return id === 1 || id === 5;
  }

  detalleLink(solicitud: any): string[] {
    const id = Number(solicitud.idEstadoSolicitud_NeoEstadoSolicitud);
    const sid = String(solicitud.idSolicitud);
    switch (id) {
      case 7:
        return ['/microempresario/perfil/ofertas', sid];
      case 12:
        return ['/microempresario/encuesta-satifaccion', sid];
      default:
        return [PERFIL_HUB_ROUTE];
    }
  }

  /** ID de solicitud → detalle compartido (`/solicitud/microempresario/:id`). */
  detalleSolicitudLink(solicitud: any): string[] {
    return ['/solicitud', 'microempresario', String(solicitud.idSolicitud)];
  }

  onVerDetalle(solicitud: any, event?: Event): void {
    event?.preventDefault();
    if (!this.verDetalleVaAlHub(solicitud)) {
      // Detalle lectura: no arrastrar draft/% de otra solicitud en curso.
      this._perfilSolicitud.limpiarContextoCliente();
      void this._router.navigate(this.detalleSolicitudLink(solicitud));
      return;
    }
    const sid = String(solicitud.idSolicitud ?? '');
    this._perfilSolicitud.prepararRetomar(sid, {
      monto: solicitud.monto != null ? String(solicitud.monto) : undefined,
      plazo: solicitud.plazo != null ? String(solicitud.plazo) : undefined,
    });
    void this._router.navigateByUrl(PERFIL_HUB_ROUTE);
  }

  getSolicitudes(idEmpresario: number): void {
    this._microempresario.getSolicitudes(idEmpresario).subscribe((data: any) => {
      this.aplicarSolicitudesCargadas(Array.isArray(data) ? data : []);
    });
  }

  private aplicarSolicitudesCargadas(rows: any[]): void {
    this.solicitudes = rows;
    this.solicitudesCargadas = true;
    this.idSolicitudProceso = '';
    this.idsolicitudDevuelta = null;
    this.observacionDevolucion = null;

    for (const x of this.solicitudes) {
      const estado = Number(x.idEstadoSolicitud_NeoEstadoSolicitud);
      if (estado === 5) {
        this.idsolicitudDevuelta = x.idSolicitud;
        this.observacionDevolucion =
          (x.nombreMotivoDevolucion_NeoMotivoDevolucion ?? '') +
          ': \n' +
          (x.observaciones_neoHistoriaSolicitud ?? '');
      }
      if (estado === 1) {
        this.idSolicitudProceso = x.idSolicitud;
      }
    }

    const enCurso = this.encontrarSolicitudEnCurso(this.solicitudes);
    if (
      enCurso &&
      Number(enCurso.idEstadoSolicitud_NeoEstadoSolicitud) === 1
    ) {
      this.evaluarProgresoSolicitudEnCurso(enCurso);
    }
  }

  /**
   * CTA por estado (misma apariencia que Ver detalle).
   * No incluye Continuar/Modificar: Ver detalle cubre 1 y 5.
   */
  esCtaOfertas(solicitud: any): boolean {
    return Number(solicitud?.idEstadoSolicitud_NeoEstadoSolicitud) === 7;
  }

  accionContextualLabel(solicitud: any): string {
    const id = Number(solicitud?.idEstadoSolicitud_NeoEstadoSolicitud);
    switch (id) {
      case 7: {
        const n = Number(solicitud?.cantidadOfertas);
        if (n === 1) {
          return 'Revisar 1 oferta';
        }
        if (n > 1) {
          return `Revisar ${n} ofertas`;
        }
        return 'Revisar ofertas';
      }
      case 12:
        return 'Registrar encuesta satisfacción';
      case 8:
        return this.copy.solicitudes.explorarOportunidades;
      case 20:
      case 22:
        return this.copy.solicitudes.sinCobertura;
      default:
        return '';
    }
  }

  onAccionContextual(solicitud: any, event?: Event): void {
    event?.preventDefault();
    const id = Number(solicitud?.idEstadoSolicitud_NeoEstadoSolicitud);
    if (id === 8 || id === 20 || id === 22) {
      this.setTextModal(id === 8 ? 8 : 20, solicitud.idSolicitud);
      return;
    }
    if (id === 7) {
      this._analyticsTag.trackCtaClick({
        ctaLabel: this.accionContextualLabel(solicitud),
        ctaSection: 'home',
        ctaComponent: 'home-solicitudes',
        ctaElementId: 'btn-home-revisar-ofertas',
        hu: '8209',
      });
    }
    // 7 / 12: ofertas o encuesta (no confundir con Ver detalle → ficha)
    void this._router.navigate(this.detalleLink(solicitud));
  }

  setTextModal(idEstado: number, idSolicitud: unknown): void {
    this.idSolicitud = idSolicitud;
    this.infoModalVariant = idEstado === 8 ? 'sin-ofertas' : 'sin-cobertura';
    this.infoModalOpen = true;
  }

  closeInfoModal(): void {
    if (this.finalizandoInfoModal) {
      return;
    }
    this.infoModalOpen = false;
  }

  cargarDatosTabla(): void {
    this._microempresario
      .getSolicitudesAprobadas(this.user.idEmpresario, this.paginaActual)
      .subscribe({
        next: (response: SolicitudesAprobadasResponse) => {
          if (response?.exitoso === true) {
            this.solicitudesAprobadas = response.data ?? [];
            this.totalPaginas = response.paginas ?? null;
          } else {
            this.solicitudesAprobadas = [];
          }
        },
        error: () => {
          this.solicitudesAprobadas = [];
        },
      });
  }

  pages(): unknown[] {
    return new Array(this.totalPaginas ?? 0);
  }

  changePage(i: number): void {
    this.paginaActual = i;
    this.cargarDatosTabla();
  }

  finalizar(): void {
    this.finalizandoInfoModal = true;
    this._microempresario
      .getFinalizarSolicitud(this.idSolicitud)
      .subscribe({
        next: (response: any) => {
          this.finalizandoInfoModal = false;
          if (response.exitoso === true) {
            this.infoModalOpen = false;
            this.getSolicitudes(+this._user.getUser().idEmpresario);
            this._sweetAlert.successModal(response.mensaje);
          }
        },
        error: () => {
          this.finalizandoInfoModal = false;
        },
      });
  }

  getMensajeSinCobertura(): void {
    this.loadParametroValor(
      PARAMETRO_MENSAJE_SIN_COBERTURA,
      (valor) => {
        this.mensajeSinCobertura = valor;
      },
      'Ocurrió un error en el servicio'
    );
  }

  validarRestricciones(): void {
    this._analyticsTag.trackCtaClick({
      ctaLabel: this.copy.ctaBar.solicitarCredito,
      ctaSection: 'home',
      ctaComponent: 'home-cta-bar',
      ctaElementId: 'btn-home-solicitar-credito',
      hu: '8099',
    });
    if (!this.solicitudesCargadas) {
      this._microempresario
        .getSolicitudes(+this._user.getUser().idEmpresario)
        .subscribe((data: any) => {
          this.solicitudes = Array.isArray(data) ? data : [];
          this.solicitudesCargadas = true;
          this.continuarSolicitarCredito();
        });
      return;
    }
    this.continuarSolicitarCredito();
  }

  private continuarSolicitarCredito(): void {
    // Borrador (1) o Devuelta (5) → hub / retomar. Cualquier otro → validar creación nueva.
    const enCurso = this.encontrarSolicitudEnCurso(this.solicitudes);
    if (enCurso) {
      this.abrirSolicitudEnCurso(enCurso);
      return;
    }
    this.abrirNuevaSolicitud();
  }

  private encontrarSolicitudEnCurso(lista: any[]): any | null {
    const rows = Array.isArray(lista) ? lista : [];
    const borrador = rows.find(
      (s) => Number(s.idEstadoSolicitud_NeoEstadoSolicitud) === 1
    );
    if (borrador) {
      return borrador;
    }
    return (
      rows.find((s) => Number(s.idEstadoSolicitud_NeoEstadoSolicitud) === 5) ??
      null
    );
  }

  private abrirSolicitudEnCurso(solicitud: any): void {
    const id = String(solicitud.idSolicitud ?? '');
    if (!id) {
      this.abrirNuevaSolicitud();
      return;
    }
    this._perfilSolicitud.prepararRetomar(id, {
      monto: solicitud.monto != null ? String(solicitud.monto) : undefined,
      plazo: solicitud.plazo != null ? String(solicitud.plazo) : undefined,
    });
    void this._router.navigateByUrl(PERFIL_HUB_ROUTE);
  }

  private abrirNuevaSolicitud(): void {
    // Validar en home ANTES de ir a monto/plazo (solo si no hay borrador/devuelta).
    this._microempresario
      .validarRestricciones(+this._user.getUser().idEmpresario)
      .subscribe({
        next: (response: any) => {
          if (!this.isRestriccionExitosa(response)) {
            void this._sweetAlert.infoModal(
              '¡Atención!',
              false,
              response?.error ||
                'Actualmente no puedes crear una solicitud ya que tienes una en trámite.'
            );
            return;
          }
          this._perfilSolicitud.prepararNueva();
          if (this.isSinCobertura(response)) {
            this._sweetAlert
              .infoModal('Advertencia', true, this.mensajeSinCobertura)
              .then((result) => {
                if (result.isConfirmed) {
                  this.irANuevaSolicitud();
                }
              });
            return;
          }
          this.irANuevaSolicitud();
        },
        error: () => {
          void this._sweetAlert.errorModal(
            'Error',
            false,
            'No se pudo validar si puedes crear una nueva solicitud. Intenta de nuevo.'
          );
        },
      });
  }

  /** exitoso del back puede venir boolean o string. */
  private isRestriccionExitosa(response: any): boolean {
    const v = response?.exitoso;
    return v === true || v === 'true' || v === 1 || v === '1';
  }

  private isSinCobertura(response: any): boolean {
    const c = response?.cobertura;
    return c === false || c === 'false' || c === 0 || c === '0';
  }

  private irANuevaSolicitud(): void {
    void this._router.navigateByUrl('/microempresario/perfil/solicita-credito');
  }

  modalCerrarSolicitud(idSolicitud: unknown): void {
    this.numeroSolicitud = idSolicitud as string | number;
    this.observacionCierreSolicitud = '';
    this.mensaje = '';
    this.cancelarModalStep = 'form';
    this.confirmandoCancelacion = false;
    this.cancelarModalOpen = true;
  }

  closeCancelarModal(): void {
    if (this.confirmandoCancelacion) {
      return;
    }
    this.cancelarModalOpen = false;
    this.cancelarModalStep = 'form';
    this.observacionCierreSolicitud = '';
    this.mensaje = '';
  }

  onCancelarSolicitarConfirmacion(observacion: string): void {
    this.observacionCierreSolicitud = observacion;
    cancelarSolicitud.idSolicitud = String(this.numeroSolicitud ?? '');
    cancelarSolicitud.idUsuario = Number(this.user.idUsuario);
    cancelarSolicitud.observacion = observacion;
    this.cancelarModalStep = 'confirm';
    this.getMensajeCierreSolisitud();
  }

  onCancelarConfirmar(): void {
    this.confirmo();
  }

  getMensajeCierreSolisitud(): void {
    this.loadParametroValor('PAR-085', (valor) => {
      this.mensaje = valor;
    });
  }

  confirmo(): void {
    if (this.confirmandoCancelacion) {
      return;
    }
    this.confirmandoCancelacion = true;
    this._microempresario
      .cerrarSolicitudMicroempresario(cancelarSolicitud)
      .subscribe({
        next: (response: any) => {
          this.confirmandoCancelacion = false;
          this.cancelarModalOpen = false;
          this.cancelarModalStep = 'form';
          if (response.exitoso) {
            this._sweetAlert.successModal('Solicitud cerrada');
          } else {
            this._sweetAlert.errorModal(
              'Error!',
              true,
              'Se produjo un error en el servicio!'
            );
          }
        },
        error: (error) => {
          this.confirmandoCancelacion = false;
          this.cancelarModalOpen = false;
          this.cancelarModalStep = 'form';
          this._sweetAlert.errorModal('Error!', true, error);
        },
      });
    this.observacionCierreSolicitud = '';
    window.setTimeout(() => {
      location.reload();
    }, 3000);
  }

  private esSolicitudCompletaParaEnvio(response: {
    porcentaje?: number | null;
    camposLlenados?: number;
    camposObligatorios?: number;
  }): boolean {
    const porcentaje = Math.round(Number(response.porcentaje ?? 0));
    const obligatorios = Number(response.camposObligatorios ?? 0);
    const llenados = Number(response.camposLlenados ?? 0);
    if (obligatorios > 0) {
      return llenados >= obligatorios && porcentaje === 100;
    }
    return porcentaje === 100;
  }

  getPorcentajeProcesoSolicitud(tipoPersona: string): void {
    this._microempresario
      .getPorcentajeSolicitudProceso(
        tipoPersona,
        +this._user.getUser().idEmpresario
      )
      .subscribe({
        next: (response: PorcentajeSolicitudResponse) => {
          if (response.exitoso) {
            this.aplicarProgresoExitoso(response);
            return;
          }
          this.idSolicitudProceso = '';
        },
        error: () => {
          this.idSolicitudProceso = '';
        },
      });
  }

  getMontoCreditoExpress(): void {
    this.loadParametroValor(PARAMETRO_MONTO_MAX_CREDITO_EXPRESS, (valor) => {
      this.montoMaxExpress = Number(valor);
    });
    this.loadParametroValor(PARAMETRO_MONTO_MIN_CREDITO_EXPRESS, (valor) => {
      this.montoMinExpress = Number(valor);
    });
    this.loadParametroValor(PARAMETRO_PLAZO_MAX_CREDITO_EXPRESS, (valor) => {
      this.plazoMaxExpress = Number(valor);
    });
  }

  getSolicitudCompleta(): void {
    this.loadParametroValor(SOLICITUD_COMPLETA, (valor) => {
      this.solicitudCompleta = valor;
    });
  }

  getDocumentosVencidos(): void {
    this.loadParametroValor(DOCUMENTOS_VENCIDOS, (valor) => {
      this.documentosVencidos = valor;
    });
  }

  getMensajeEnvio(): void {
    this.loadParametroValor(MENSAJE_ENVIO_SOLICITUD, (valor) => {
      this.mensajeEnvio = valor;
    });
  }

  closeEnviarModal(): void {
    if (this.enviandoSolicitud) {
      return;
    }
    this.enviarModalOpen = false;
  }

  onEnviarRevisar(): void {
    this.enviarModalOpen = false;
    void this._router.navigateByUrl(PERFIL_HUB_ROUTE);
  }

  onEnviarSolicitudV2(): void {
    if (this.enviandoSolicitud) {
      return;
    }
    this.enviandoSolicitud = true;
    this._perfilSolicitud.validarRegistroParaEnvio().subscribe((registro) => {
      if (!registro.ok) {
        this.enviandoSolicitud = false;
        void this._sweetAlert
          .infoModal(
            this.mensajeRegistro ||
              'Tu registro está incompleto. Actualiza tus datos para poder enviar la solicitud.',
            false
          )
          .then((result) => {
            if (result.isConfirmed) {
              void this._router.navigate(['/microempresario/actualizar-datos']);
            }
          });
        return;
      }
      this._perfilSolicitud.validarDocumentosParaEnvio().subscribe((check) => {
        if (!check.ok) {
          this.enviandoSolicitud = false;
          void this._sweetAlert.errorModal(
            'Error!',
            true,
            'Los documentos cargados presentan inconsistencias, por favor revise nuevamente'
          );
          return;
        }
        this._perfilSolicitud.enviarSolicitud().subscribe((res) => {
          this.enviandoSolicitud = false;
          if (!res.exitoso) {
            void this._sweetAlert.errorModal(
              'Error!',
              true,
              res.error || 'No se pudo enviar la solicitud'
            );
            return;
          }
          this.enviarModalOpen = false;
          const id =
            this._perfilSolicitud.idSolicitud ||
            this.idSolicitudProceso ||
            null;
          if (id) {
            void this._router.navigate([
              PERFIL_SOLICITUD_ENVIADA_ROUTE,
              String(id),
            ]);
          } else {
            void this._router.navigateByUrl(PERFIL_SOLICITUD_ENVIADA_ROUTE);
          }
        });
      });
    });
  }

  saveSolicitud(): void {
    this._microempresario
      .crearSolicitud(this.idSolicitudProceso)
      .subscribe((data: any) => {
        if (data.exitoso) {
          $('#aceptarModal').modal('hide');
          void this._router.navigateByUrl('/LandingAceptacionCreacionCredito');
        } else {
          this._sweetAlert.errorModal('Error!', true, data.error);
        }
      });
  }

  validarRegistro(): void {
    if (this.user.tipoPersona === 'juridica') {
      this._microempresario
        .getValidarRegistroJuridico(this.user.idEmpresario)
        .subscribe((resp: any) => {
          this.manejarValidacionRegistro(resp);
        });
      return;
    }
    this._microempresario
      .getValidarRegistroNatural(
        this.user.idEmpresarioNatural,
        this.user.idEmpresario
      )
      .subscribe((resp: any) => {
        this.manejarValidacionRegistro(resp);
      });
  }

  getMensajeValidarRegsitro(): void {
    this.loadParametroValor(MENSAJE_VALIDAR_REGISTRO, (valor) => {
      this.mensajeRegistro = valor;
      this.validarRegistro();
    });
  }

  private evaluarProgresoSolicitudEnCurso(enCurso: any): void {
    const tipoPersona = this._user.getUser().tipoPersona;
    if (tipoPersona === 'juridica') {
      this.getPorcentajeProcesoSolicitud(tipoPersona);
      return;
    }
    const dentroExpress =
      this.montoMinExpress != null &&
      this.montoMaxExpress != null &&
      this.plazoMaxExpress != null &&
      enCurso.monto >= this.montoMinExpress &&
      enCurso.monto <= this.montoMaxExpress &&
      enCurso.plazo <= this.plazoMaxExpress;

    this.getPorcentajeProcesoSolicitud(
      dentroExpress ? 'express' : tipoPersona
    );
  }

  private aplicarProgresoExitoso(response: PorcentajeSolicitudResponse): void {
    this.porcentajeProcesoSolicitud = Number(response.porcentaje ?? 0);
    this.idSolicitudProceso = String(response.solicitud ?? '');
    this._user.setIdSolicitud(+this.idSolicitudProceso);

    if (
      this.esSolicitudCompletaParaEnvio(response) &&
      response.validezDocumentos
    ) {
      this.mostrarAvisoEnvioSolicitud();
      return;
    }

    if (response.validezDocumentos === false) {
      this._sweetAlert.infoModal(
        '¡' + response.estadoDocumentos + '!',
        true,
        this.documentosVencidos
      );
    }
  }

  private mostrarAvisoEnvioSolicitud(): void {
    this.enviarModalOpen = true;
  }

  private manejarValidacionRegistro(resp: { exitoso?: boolean }): void {
    if (resp.exitoso) {
      return;
    }
    this._sweetAlert.infoModal(this.mensajeRegistro, false).then((result) => {
      if (result.isConfirmed) {
        void this._router.navigate(['/microempresario/actualizar-datos']);
      }
    });
  }

  private loadParametroValor(
    idParametro: string,
    onSuccess: (valor: string) => void,
    errorMessage?: string
  ): void {
    const body: ParametroFilterBody = {
      idParametro,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(body).subscribe({
      next: (response: ParametroFilterResponse) => {
        const valor = response?.data?.[0]?.valorParametro;
        if (valor != null && valor !== '') {
          onSuccess(String(valor));
        }
      },
      error: (error) => {
        this._sweetAlert.errorModal(
          errorMessage ? 'Error' : 'Error!',
          true,
          errorMessage ?? error?.error ?? error
        );
      },
    });
  }
}
